import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { ToggleSwitchProps } from './models';

import * as styles from './styles';

export const ToggleSwitch = React.memo(styled(
  ({ className, defaultValue, value, onChange, dataAt = 'toggleSwitch' }: ToggleSwitchProps) => {
    const [checked, setChecked] = useState<boolean>(value || defaultValue || false);

    const onCheckChange = useCallback(() => {
      const newCheck = !checked;
      if (!value) setChecked(newCheck);
      if (onChange) onChange(newCheck);
    }, [checked]);

    return (
      <label {...{ className }}>
        <input data-at={dataAt} checked={checked} onChange={onCheckChange} type="checkbox" />
        <span className="slider" />
      </label>
    );
  }
)`
  ${styles.ToggleSwitch}
`);
